module.exports = __webpack_public_path__ + "img/744.e3b785bc.jpg";